module.exports = __webpack_public_path__ + "static/bohater_3-e2fc9668c5aafe75a77c2fd33affe4d3.png";